import { useState } from "react";
import * as yup from "yup";
import { StringHelper } from "../../../assets/utils/helpers";
import { Constants } from "../../../assets/utils/lib/constants";
import Drawer from "../../../assets/vfx/drawer/drawer";
import Form from "../../../assets/vfx/form/form";
import { LookupQuestionTypeDto } from "../../../services/dto";
import { DrawerFormSaveResult, hasClientErrorOperationStatusCode } from "../../../assets/utils/lib";

const validationSchema = yup.object().shape({
  name: yup.string().required("Name is required."),
  description: yup.string().optional(),
});
interface QuestionTypeFromProps {
    data?: LookupQuestionTypeDto | undefined;
    show: boolean;
    onHide: () => void;
    onSave: (values: LookupQuestionTypeDto) => DrawerFormSaveResult;
}

export const QuestionTypeForm = (props: QuestionTypeFromProps) => {
  let questionType: LookupQuestionTypeDto | undefined = props.data;
  const [hasOptions, setHasOptions] = useState(props.data?.hasOptions ?? false);
  const [hasRangeRestrictions, setHasRangeRestrictions] = useState(
    props.data?.hasRangeRestrictions ?? false
  );
  let title: string =
    StringHelper.whenNullOrEmpty(questionType?.id, Constants.emptyGuid) ===
    Constants.emptyGuid
      ? "New Question Type"
      : "Edit Question Type";

  const onSubmit = (data: LookupQuestionTypeDto) => {
    return Promise.resolve(props.onSave(data)).then((result) => {
        if (hasClientErrorOperationStatusCode(result)) {
            return;
        }

        props.onHide();
    });
  };

  const isNew = !questionType?.id || questionType?.id === Constants.emptyGuid;
  const isLoading = props.show && !isNew && !questionType;
  return (
    <Drawer.Form
      className="w-30"
      show={props.show}
      backdrop={true}
      placement="end"
      scroll={true}
      onHide={props.onHide}
      title={title}
      initialValues={questionType ?? {}}
      validationSchema={validationSchema}
      on_Submit={onSubmit}
    >
      <Form.Text
        name="name"
        placeholder="Enter text"
        label="Name"
        isLoading={isLoading}
      />
      <Form.TextArea
        name="description"
        rows={3}
        label="Description"
        isLoading={isLoading}
      />
      <Form.Checkbox
        name="hasOptions"
        label="Has options"
        isLoading={isLoading}
        key="hasOptions"
        checked={hasOptions}
        onChange={(e: any) => setHasOptions(e.target.checked)}
      />

      <Form.Checkbox
        name="hasRangeRestrictions"
        label="Has Range Restrictions"
        isLoading={isLoading}
        key="hasRangeRestrictions"
        checked={hasRangeRestrictions}
        onChange={(e: any) => setHasRangeRestrictions(e.target.checked)}
      />
    </Drawer.Form>
  );
};
